import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export interface UserInvitation {
  id: number
  uuid: string
  fullName: string
  email?: string
  mobile?: string
  status: string
  created_at: string
}

export function getUserInvitationsAction(
  userId: string,
  page: number = 1
): Promise<ApiPaginationResponse<UserInvitation[]>> {
  return api.get<ApiPaginationResponse<UserInvitation[]>>(`/users/${userId}/invitations`, { params: { page } })
}
